/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TenantThemeColors } from './TenantThemeColors';
import {
    TenantThemeColorsFromJSON,
    TenantThemeColorsFromJSONTyped,
    TenantThemeColorsToJSON,
} from './TenantThemeColors';
import type { TenantThemeVar } from './TenantThemeVar';
import {
    TenantThemeVarFromJSON,
    TenantThemeVarFromJSONTyped,
    TenantThemeVarToJSON,
} from './TenantThemeVar';

/**
 * Portal color scheme. Absent means the default palette. colors feed the FE token derivation; vars pin individual tokens (custom gradients, image washes, component colors) without freezing the rest of the derived theme.
 * @export
 * @interface TenantTheme
 */
export interface TenantTheme {
    /**
     * Theme schema version, currently 1. Guards future migrations of this shape.
     * @type {number}
     * @memberof TenantTheme
     */
    version?: number;
    /**
     * 
     * @type {TenantThemeColors}
     * @memberof TenantTheme
     */
    colors?: TenantThemeColors;
    /**
     * 
     * @type {Array<TenantThemeVar>}
     * @memberof TenantTheme
     */
    vars?: Array<TenantThemeVar>;
}

/**
 * Check if a given object implements the TenantTheme interface.
 */
export function instanceOfTenantTheme(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantThemeFromJSON(json: any): TenantTheme {
    return TenantThemeFromJSONTyped(json, false);
}

export function TenantThemeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantTheme {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': !exists(json, 'version') ? undefined : json['version'],
        'colors': !exists(json, 'colors') ? undefined : TenantThemeColorsFromJSON(json['colors']),
        'vars': !exists(json, 'vars') ? undefined : ((json['vars'] as Array<any>).map(TenantThemeVarFromJSON)),
    };
}

export function TenantThemeToJSON(value?: TenantTheme | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
        'colors': TenantThemeColorsToJSON(value.colors),
        'vars': value.vars === undefined ? undefined : ((value.vars as Array<any>).map(TenantThemeVarToJSON)),
    };
}

